import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@damofire/data-security';
import { UserService } from '@damofire/data-stas';

@Pipe({ name: 'toUserName', standalone: true })
export class ToUserNamePipe implements PipeTransform {
  constructor(private readonly userService: UserService) {}

  transform(value: string, args?: any): any {
    return this.resolveUser(value);
  }

  private async resolveUser(user: string): Promise<string> {
    if (!user) {
      return '';
    }

    let matchingUser: User;
    if (user.includes('@')) {
      const searchRes = await this.userService.search({ filters: { email: user }, size: 1 });
      matchingUser = searchRes.result.length ? searchRes.result[0] : null;
    } else {
      matchingUser = await this.userService.get(user);
    }

    return matchingUser ? `${matchingUser.firstName} ${matchingUser.lastName}` : user;
  }
}
